import { render, staticRenderFns } from "./BenefitsDetails.vue?vue&type=template&id=09395a3c&scoped=true"
import script from "./BenefitsDetails.vue?vue&type=script&lang=js"
export * from "./BenefitsDetails.vue?vue&type=script&lang=js"
import style0 from "./BenefitsDetails.vue?vue&type=style&index=0&id=09395a3c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09395a3c",
  null
  
)

export default component.exports